@if (showSpinner) {
  <app-loader> </app-loader>
}
<html>
  <body >
    <div class="mobile-screen">
      <div class="logo-main">
        <img src="../../assets/theme1/dark-logo.png" alt="">
      </div>
      <div class="content-main">
        <h3>
          Download our new Employee Management System app!
        </h3>
      </div>
      <div class="buttons-main">
        <a class="appstore-button buttons" href=" https://play.google.com/store/apps/details?id=com.ems.kodextech">
          <div class="app-button-logo">
            <img src="../../assets/app-store-logo.png" alt="logog missing">
          </div>
          <div class="app-button-content">
            <p>Get It On</p>
            <h5>Google Play</h5>
          </div>
        </a>
          <a class="iosapp-button buttons" href="https://apps.apple.com/us/app/kodex-ems/id6503248677
          ">
          <div class="app-button-logo">
            <img src="../../assets/apple-store-logo.png" alt="logog missing">
          </div>
          <div class="app-button-content">
            <p>Download on the</p>
            <h5>App Store</h5>
          </div>
        </a>
      </div>
    </div>
  </body>
</html>

